import styled from 'styled-components';

export const UsersList = styled.ul`
    position: relative;
    list-style: none;
    padding: 0;
    margin: 0;
    padding-top: 20px;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 4px;
        opacity: 0.2;
        border-radius: 3.5px;
        background-color: #ffffff;
    }
`;

export const UsersListItem = styled.li`
    padding: 8px;
    padding-right: 15px;
    box-shadow: inset 0 -1px 0 0 rgba(255, 255, 255, 0.25);
    transition: 0.3s linear;

    &:last-of-type {
        box-shadow: none;
    }

    &:hover {
        box-shadow: rgba(255, 255, 255, 0.7) 0px -2px 0px 0px inset, rgba(255, 255, 255, 0.7) 0px 2px 0px 0px inset;
    }
`;

export const ItemWrap = styled.div`
    display: flex;
    align-items: center;
    font-family: Rubik;
    font-size: 16px;
    color: #ffffff;
`;

export const ItemSymbol = styled.span`
    margin-right: 20px;
`;

export const ItemImageWrap = styled.div`
    width: 42px;
    height: 42px;
    border: 2px solid rgba(70, 70, 70, 0.5);
    border-radius: 50%;
    overflow: hidden;
    margin-right: 20px;
`;

export const ItemImage = styled.img`
    display: block;
    min-height: 100%;
    max-width: 100%;
`;

export const ItemTitle = styled.span`
    font-family: Rubik;
    font-size: 16px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #ffffff;
`;

export const ItemStatus = styled.span`
    margin-right: 20px;
    margin-left: auto;
    font-family: Rubik;
    font-size: 16px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.25;
    letter-spacing: -0.4px;
    text-align: right;
    color: #ffffff;
`;



// WEBPACK FOOTER //
// ./src/UI/Containers/BookedUsers/style.js